export var RuleApplicationStrategy;
(function (RuleApplicationStrategy) {
    RuleApplicationStrategy["STRICTEST_TO_ALL"] = "STRICTEST_TO_ALL";
})(RuleApplicationStrategy || (RuleApplicationStrategy = {}));
